import { buildUibComponentModal, defineThisScopeBinding, elementToModalRef } from "../../../ajs/ajs-migration-utils.js";

export class CatalogViewerModalComponent {

    static selector = "modal-catalog-viewer";
    static template = `
        <a class="close-btn" href="javascript:void(0)" ng-click="close()"></a>

		<style type="text/css">
			@media (max-width: 992px) {
				body.modal-open > .modal > .modal-dialog.modal-lg {
					width: calc( 100% - 60px );
				} 
			}
		</style>

        <div ng-if="!selected_catalog">
            <div class="modal-header">
                <h3 class="modal-title">
                    <span class="mr-1">{{ 'Content catalogs' | translate }}</span>

                    <button class="btn btn-default btn-sm" ng-click="addNew()" ng-if="canEdit">{{ 'Add new' | translate }}</button>
                </h3>
            </div>


            <div class="modal-body">
                <div ng-if="catalogs.length == 0">
                    <div class="alert alert-danger"><p>{{ 'No catalogs available!' | translate }}</p></div>

                    <div ng-if="canEdit" class="">
                    </div>
                </div>

                <div ng-if="catalogs.length > 0">
                    <ul class="list-group">
                        <li class="list-group-item" ng-repeat="catalog in catalogs track by $index">
                            <h4 class="m0">
                                <button class="btn btn-link" ng-click="selectCatalog( catalog )">
                                    <span ng-hide="!catalog.title">{{ catalog.title }}</span>
                                    <i ng-if="!catalog.title" class="unnamed">{{ 'Unnamed catalog' | translate }}</i>
                                </button>

                                <span ng-if="canEdit">
                                    <button class="btn btn-xs btn-default" ng-click="openEditor( catalog )"><span class="glyphicon glyphicon-pencil"></span></button>
                                    <button class="btn btn-xs btn-danger" ng-click="removeCatalog( catalog, catalogs )"><span class="glyphicon glyphicon-remove"></span></button>
                                </span>
                            </h4>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div ng-if="selected_catalog">
            <div class="modal-header">
                <h3 class="modal-title">
                    <button class="btn btn-sm btn-default" ng-if="!catalog" ng-click="selectCatalog( null )"><b class="glyphicon glyphicon-chevron-left"></b>&nbsp;{{ 'Content catalogs' | translate }}</button>
   
                    <span ng-hide="!selected_catalog.title">{{ selected_catalog.title }}</span>

                    <span ng-if="canEdit">
                        <button class="btn btn-xs btn-default" ng-click="openEditor( catalog )">
                            <span class="glyphicon glyphicon-pencil"></span>&nbsp;{{ 'Click to edit catalog' | translate }}
                        </button>
                    </span>
                </h3>
            </div>

            <div class="modal-body">
                <ul>
                    <div class="media" ng-repeat="item in selected_catalog.items">
                        <div class="media-left">
                            <a ng-click="openItemViewer( item )">
                                <img style="width:10rem" class="media-object" src="/i/null?size=small" ng-src="{{ catalogsService.getItemMediaSrc( item ) }}">
                            </a>
                        </div>

                        <div class="media-body">
                            <h4 class="media-heading"><a ng-click="openItemViewer( item )">{{ catalogsService.getItemHeading( item ) }}</a></h4>
                            <p>{{ catalogsService.getItemDescription( item ) }}</p>
                        </div>
                    </div>
                </ul>
            </div>
        </div>
    `;

    canEdit = false;

    arrangement;

    catalogs = [];

    catalog = null;

    selected_catalog = null;

    static $inject = [ "$scope", "$element", "gameSceneService", "catalogsService" ];

    constructor(
        $scope,
        modalRef,
        gameSceneService,
        catalogsService
    ) {
        this.$scope = $scope;
        this.modalRef = elementToModalRef('modal-catalog-viewer');
        this.gameSceneService = gameSceneService;
        this.catalogsService = catalogsService;

        defineThisScopeBinding( this, $scope, [ 'arrangement', 'catalogs', 'catalog', 'selected_catalog', 'selectCatalog', 'openItemViewer', 'canEdit', 'close', 'addNew', 'modalRef', 'openEditor', 'removeCatalog', ...CatalogViewerModalComponent.$inject ]);
    }

    $onInit() {
        if (!this.arrangement) {
            this.arrangement = this.catalogsService.solveCurrentArrangement();
        }

        this.catalogs = this.catalogsService.solveCatalogs( this.arrangement );

        if (this.catalog) this.selectCatalog( this.catalog );

        if (this.arrangement && this.arrangement.$saveable && this.gameSceneService.inEditor()) {
            this.canEdit = true;
        }
    }

    async addNew() {
        if (this.canEdit){
            this.openEditor( await this.catalogsService.createCatalog() );
        }
    }

    selectCatalog( catalog ) {

        let catalog_idx = catalog ? this.catalogs.indexOf( catalog ) : -1;

        if (catalog_idx == -1) {
            this.selected_catalog = null;
        } else {
            this.selected_catalog = catalog;
        }
    }

    openEditor( catalog ) {

        if (this.canEdit && catalog) {
            
            this.catalogsService.openCatalogEditor( catalog );
                
            this.close();
        }
    }

    openItemViewer( item, catalog = this.catalog, arrangement = this.arrangement ) {

        if (item) {

            this.catalogsService.openCatalogItemViewer( item, catalog, arrangement );

            this.close();
        }
    }

    removeCatalog( catalog, catalogs = this.catalogs ) {

        if (this.canEdit) {

            let catalog_idx = catalogs.indexOf( catalog );

            if (catalog_idx == -1) return;

            if (!confirm( 'Haluatko varmasti poistaa katalogin?' )) return;
            
            this.catalogsService.removeCatalog( catalog, this.arrangement );

            this.catalogs = this.catalogsService.solveCatalogs( this.arrangement );
        }
    }

    close() {
        this.modalRef.hide();
    }
}

export const AjsCatalogViewerModalComponent = buildUibComponentModal( "modalCatalogViewer", CatalogViewerModalComponent, {
    bindings: {
        arrangement: '<',
        catalog: '<'
    }
}, {
    size: 'lg'
});
